<template>
  <div class="mangheshopgoodkeyword-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">创建分类</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           stripe
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 创建 弹层 -->
    <Modal v-model="showCreatTypeModal"
           title="创建"
           @on-ok="createType('addCate')"
           :loading="loading">
      <Form :model="cate"
            ref="addCate"
            :rules="cateValidate"
            action="javascript:void(0)">
        <FormItem label="名称"
                  prop="title">
          <Input v-model="cate.title"
                 placeholder />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
  
  <script>
export default {
  name: "mangheshopgoodkeyword-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      cate: {
        title: "", // 当前
      },
      formItem: {},
      tablelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      //  规则
      cateValidate: {
        title: [
          {
            required: true,
            message: "名称必须填写",
            trigger: "blur"
          }
        ]
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "名称",
          key: "title",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  marginLeft: params.row.left + "px"
                }
              },
              params.row.title
            );
          }
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status == 1 ? true : false //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 130,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeType(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      showCreatTypeModal: false,
      currentId: 0 // 编辑，当前id
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {},
  methods: {
    // 获取产品列表
    getTableList: function () {
      var self = this;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key,
      };
      this.$api.mangheshopgoodkeyword.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    addGoodCate: function () {
      this.showCreatTypeModal = true;
      this.currentId = 0;
      this.cate.title = "";
      this.cate.sort = "0";
      this.thumblist = new Array();
    },
    // 编辑
    editType: function (id) {
      this.currentId = id;
      this.showCreatTypeModal = true;
      this.$api.mangheshopgoodkeyword.detail({ id: id }).then(res => {
        if (res.code == 200) {
          this.cate = res.result;
        }
      });
    },
    // 提交祝福
    createType: function (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            title: this.cate.title, // 分类名称
          };
          if (
            this.currentId == null ||
            this.currentId == 0 ||
            this.currentId == ""
          ) {
            this.$api.mangheshopgoodkeyword.create(params).then(res => {
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          } else {
            params.id = this.currentId;
            this.$api.mangheshopgoodkeyword.edit(params).then(res => {
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showCreatTypeModal = false;
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    removeType: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>是否确定删除该？</p>",
        onOk: () => {
          this.$api.mangheshopgoodkeyword
            .remove({
              id: id
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.mangheshopgoodkeyword.status({ id: index, status: value == false ? 0 : 1 }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.mangheshopgoodkeyword.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  }
};
  </script>
  
  